import React, { Fragment } from 'react';
import TinymceFloatPanel from '../common/TinymceFloatPanel';
import { getCategoryDisplayName } from '../../lib/PostUtils';

export function CategoryListPanel (props) {
  const {
    categories, onSelect, menuRef,
    handleKeyDownOnMenu, selectedIdx, setSelectedIdx,
  } = props;

  let itemIndex = 0;

  const getNextIndex = () => (itemIndex++);

  return (
    <TinymceFloatPanel
      menuRef={menuRef}
      setSelectedIdx={setSelectedIdx}
      handleKeyDownOnMenu={handleKeyDownOnMenu}
    >
      <CategoryItem
        index={getNextIndex()}
        selectedIdx={selectedIdx}
        setSelectedIdx={setSelectedIdx}
        categoryId={0}
        name={'카테고리 없음'}
        viewChanel={null}
        onSelect={onSelect}
      />

      {categories.filter(c => c.id >= 0).map(category => <Fragment key={category.id} >
        <CategoryItem
          index={getNextIndex()}
          selectedIdx={selectedIdx}
          setSelectedIdx={setSelectedIdx}
          categoryId={category.id}
          name={getCategoryDisplayName(category)}
          viewChanel={category.viewChannel}
          onSelect={onSelect}
        />

        {category.children && category.children.map(sub => <CategoryItem
          key={category.id}
          index={getNextIndex()}
          selectedIdx={selectedIdx}
          setSelectedIdx={setSelectedIdx}
          categoryId={sub.id}
          name={`- ${getCategoryDisplayName(sub)}`}
          viewChanel={sub.viewChannel}
          onSelect={onSelect}
        />
        )}
      </Fragment>
      )}
    </TinymceFloatPanel>
  );
}

function CategoryItem (props) {
  const { categoryId, name, viewChanel, onSelect, index, selectedIdx, setSelectedIdx } = props;
  const tabIndex = (selectedIdx === index) ? 0 : -1;

  return (
    <div
      key={categoryId}
      onClick={() => onSelect(categoryId, viewChanel)}
      onMouseOver={() => setSelectedIdx(index)}
      tabIndex={tabIndex}
      role="menuitem"
      aria-label={name}
      className={`mce-menu-item ${tabIndex === 0 ? 'mce-active' : ''}`}
      category-id={categoryId}
      view-channel={viewChanel}
    >
      <span className="mce-text">{name}</span>
    </div>
  );
}
